import { connect } from 'react-redux';

// Actions
import { getOfficesShortList } from '../Offices/officesActions';
import { getOrganizationMembersList } from '../Projects/projectsActions';
// Component
import ClockInOut from './ClockInOut';
import { getClockInOutList } from './clockInOutActions';
import { fetchAttendanceTimeline } from './clockInOutActions';
// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  clockInOutList: state.clockInOut.clockInOutList,
  isLoading: state.clockInOut.isLoading,
  memberShortListIsLoading: state.project.memberShortListIsLoading,

  organizationMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,

  // pagination
  clockInOutListCount: state.clockInOut.clockInOutListCount,
  clockInOutPageSize: state.clockInOut.clockInOutPageSize,

  attendanceTimeline: state.clockInOut.attendanceTimeline,
  attendanceTimelineLoading: state.clockInOut.attendanceTimelineLoading,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getClockInOutList: payload => dispatch(getClockInOutList(payload)),
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  getOrganizationMembersList: details =>
    dispatch(getOrganizationMembersList({ ...details })),
  fetchAttendanceTimeline: payload => dispatch(fetchAttendanceTimeline(payload)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(ClockInOut);
